import React, { useState } from 'react';

const FailureSwitching = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  
  const [switchingData, setSwitchingData] = useState([
    {
      id: 1,
      operator: 'Airtel',
      primaryAPI: 'API Provider 1',
      fallbackAPI: 'API Provider 2',
      errorCode: '500',
      failureCount: 15,
      switchCount: 8,
      status: 'Active',
      lastSwitch: '2025-11-05 10:30 AM'
    },
    {
      id: 2,
      operator: 'Vodafone',
      primaryAPI: 'API Provider 2',
      fallbackAPI: 'API Provider 3',
      errorCode: '502, 503',
      failureCount: 23,
      switchCount: 12,
      status: 'Active',
      lastSwitch: '2025-11-05 09:45 AM'
    },
    {
      id: 3,
      operator: 'Jio',
      primaryAPI: 'API Provider 1',
      fallbackAPI: 'API Provider 4',
      errorCode: '404',
      failureCount: 8,
      switchCount: 5,
      status: 'Active',
      lastSwitch: '2025-11-05 08:20 AM'
    },
    {
      id: 4,
      operator: 'BSNL',
      primaryAPI: 'API Provider 3',
      fallbackAPI: 'API Provider 1',
      errorCode: 'Timeout',
      failureCount: 45,
      switchCount: 25,
      status: 'Inactive',
      lastSwitch: '2025-11-04 05:30 PM'
    }
  ]);

  const statuses = ['all', 'Active', 'Inactive'];

  const filteredData = switchingData.filter(item => {
    const matchesSearch = 
      item.operator.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.primaryAPI.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.fallbackAPI.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = selectedStatus === 'all' || item.status === selectedStatus;
    
    return matchesSearch && matchesStatus;
  });

  const handleStatusToggle = (id) => {
    setSwitchingData(switchingData.map(item => 
      item.id === id 
        ? { ...item, status: item.status === 'Active' ? 'Inactive' : 'Active' }
        : item
    ));
  };

  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1">Failure Switching</h2>
          <p className="text-muted mb-0">Manage automatic switching on API failures</p>
        </div>
        <button className="btn btn-primary">
          <i className="bi bi-plus-circle me-2"></i>
          Add Failure Rule
        </button>
      </div>

      <div className="card mb-4">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">Search</label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-search"></i>
                </span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by operator or API provider..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <label className="form-label">Filter by Status</label>
              <select
                className="form-select"
                value={selectedStatus}
                onChange={(e) => setSelectedStatus(e.target.value)}
              >
                {statuses.map((status, index) => (
                  <option key={index} value={status}>
                    {status === 'all' ? 'All Status' : status}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-3 mb-3">
          <div className="card bg-danger text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Failures</h6>
                  <h3 className="mb-0">
                    {switchingData.reduce((sum, item) => sum + item.failureCount, 0)}
                  </h3>
                </div>
                <i className="bi bi-exclamation-triangle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-warning text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Total Switches</h6>
                  <h3 className="mb-0">
                    {switchingData.reduce((sum, item) => sum + item.switchCount, 0)}
                  </h3>
                </div>
                <i className="bi bi-arrow-left-right fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-success text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Active Rules</h6>
                  <h3 className="mb-0">
                    {switchingData.filter(item => item.status === 'Active').length}
                  </h3>
                </div>
                <i className="bi bi-check-circle-fill fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3 mb-3">
          <div className="card bg-info text-white">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h6 className="mb-1">Switch Rate</h6>
                  <h3 className="mb-0">54.9%</h3>
                </div>
                <i className="bi bi-graph-up fs-1 opacity-50"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Operator</th>
                  <th>Primary API</th>
                  <th>Fallback API</th>
                  <th>Error Code</th>
                  <th>Failures</th>
                  <th>Switches</th>
                  <th>Status</th>
                  <th>Last Switch</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item) => (
                    <tr key={item.id}>
                      <td>#{item.id}</td>
                      <td>
                        <i className="bi bi-phone-fill text-primary me-2"></i>
                        {item.operator}
                      </td>
                      <td>
                        <span className="badge bg-secondary">{item.primaryAPI}</span>
                      </td>
                      <td>
                        <span className="badge bg-info">{item.fallbackAPI}</span>
                      </td>
                      <td>
                        <span className="badge bg-danger">{item.errorCode}</span>
                      </td>
                      <td>
                        <span className="badge bg-warning text-dark">{item.failureCount}</span>
                      </td>
                      <td>
                        <span className="badge bg-primary">{item.switchCount}</span>
                      </td>
                      <td>
                        <span className={`badge ${
                          item.status === 'Active' ? 'bg-success' : 'bg-danger'
                        }`}>
                          {item.status}
                        </span>
                      </td>
                      <td>
                        <small className="text-muted">{item.lastSwitch}</small>
                      </td>
                      <td>
                        <div className="btn-group btn-group-sm" role="group">
                          <button className="btn btn-outline-primary" title="Edit">
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button 
                            className={`btn ${
                              item.status === 'Active' ? 'btn-outline-danger' : 'btn-outline-success'
                            }`}
                            onClick={() => handleStatusToggle(item.id)}
                            title={item.status === 'Active' ? 'Deactivate' : 'Activate'}
                          >
                            <i className={`bi ${
                              item.status === 'Active' ? 'bi-toggle-on' : 'bi-toggle-off'
                            }`}></i>
                          </button>
                          <button className="btn btn-outline-danger" title="Delete">
                            <i className="bi bi-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center py-5">
                      <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                      <p className="text-muted mb-0">No failure rules found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="card-footer">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-muted">
              Showing {filteredData.length} of {switchingData.length} rules
            </div>
            <div>
              <button className="btn btn-sm btn-outline-primary me-2">
                <i className="bi bi-download me-1"></i>
                Export
              </button>
              <button className="btn btn-sm btn-outline-secondary">
                <i className="bi bi-arrow-clockwise me-1"></i>
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FailureSwitching;

